define('static/js/6zhounian', function(require, exports, module) {

  var sexennial = {
    init: function () {
      require(['static/js/jquery','static/js/swiper','static/js/proxy','static/js/newsID','static/js/common'], function ($, Swiper, _proxyJS, _newsIDJS, _commonJS) {
        var flag = false;
        var isshow = 'woman'
        var mySwiper
        initSwiper.apply(this);
        var Aduio = document.getElementById('my-audio')
        function initSwiper() {
          mySwiper = new Swiper('.swiper', {
            direction: 'vertical',
            mousewheel: true,
            height: window.innerHeight,
            on: {
              reachBeginning: function () {
                $('.f').addClass('none')
              },
              reachEnd: function () {
                $('.f').removeClass('none')
              }
            }
          })
        }
        Aduio.addEventListener('ended', (_event) => {
          $('.button').removeClass('button-active')
        });
        $('.lyric').mouseenter(function () {
          mySwiper.mousewheel.disable(); //禁止鼠标滑轮控制
        })
        $('.lyric').mouseleave(function () {
          mySwiper.mousewheel.enable(); //开启鼠标滑轮控制
        })
        $('.content-container').mouseenter(function () {
          mySwiper.mousewheel.disable(); //禁止鼠标滑轮控制
        })
        $('.content-container').mouseleave(function () {
          mySwiper.mousewheel.enable(); //开启鼠标滑轮控制
        })
        // content-container
        $('.details').on('click', function () {
          $(".mask").removeClass("none")
          $(".occupation-content").removeClass("none")
          if (isshow === 'man') {
            $(".index1").removeClass('nv1')
            $(".index2").removeClass('nv2')
            $(".index3").removeClass('nv3')
            $(".index1").children().children().addClass('nan1')
            $(".index2").children().children().addClass('nan2')
            $(".index3").children().children().addClass('nan3')
  
          } else {
            $(".index1").addClass('nv1')
            $(".index2").addClass('nv2')
            $(".index3").addClass('nv3')
            $(".index1").children().children().removeClass('nan1')
            $(".index2").children().children().removeClass('nan2')
            $(".index3").children().children().removeClass('nan3')
          }
        })
        $('.occupation-content-close').on('click', function () {
          $(".mask").addClass("none")
          $(".occupation-content").addClass("none")
        })
        $('.qfxs').mouseenter(function () {
          $('.bg-qfxs').removeClass('none')
        })
        $('.qfxs').mouseleave(function () {
          $('.bg-qfxs').addClass('none')
        })
        $('.qffm').mouseenter(function () {
          $('.bg-qffm').removeClass('none')
        })
        $('.qffm').mouseleave(function () {
          $('.bg-qffm').addClass('none')
        })
        $('.wycm').mouseenter(function () {
          $('.bg-wycm').removeClass('none')
        })
        $('.wycm').mouseleave(function () {
          $('.bg-wycm').addClass('none')
        })
        $('.yswd').mouseenter(function () {
          $('.bg-yswd').removeClass('none')
        })
        $('.yswd').mouseleave(function () {
          $('.bg-yswd').addClass('none')
        })
        // 职业icon切换
        $('.show-icon').on('click', function () {
          $(this).addClass("icon-active").siblings().removeClass("icon-active");
          var index = $(this).index()
          if (index === 2) {
            isshow = 'man'
            $(".icon-nan").addClass('icon-active-nan')
            $(".icon-nv").removeClass('icon-active-nv')
            $('.stereoscopic').addClass('stereoscopic-nan')
            $('.dj').addClass('djn')
            $('.sf').addClass('sfn')
          } else {
            isshow = 'woman'
            $(".icon-nan").removeClass('icon-active-nan')
            $(".icon-nv").addClass('icon-active-nv')
            $('.stereoscopic').removeClass('stereoscopic-nan')
            $('.dj').removeClass('djn')
            $('.sf').removeClass('sfn')
          }
        })
        //歌曲点击
        $('.button').on('click', function () {
          if (flag) {
            $('.button').removeClass('button-active')
            flag = false
            Aduio.pause()
          } else {
            console.log(Aduio)
            $('.button').addClass('button-active')
            flag = true
            Aduio.play()
          }
          console.log($('v'))
        })
        //周年庆
        $('.year-li-icon').on('click', function () {
          $(this).addClass("year-is--active").siblings().removeClass("year-is--active");
          var index = $(this).index()
          if (index === 0) {
            $(this).css({
              "left": "40px",
              'background-position-x': `-43px`
            })
            $('.welfare').addClass('is--active')
            $('.draw').removeClass('is--active')
            $('.qx').removeClass('is--active')
            $('.xrj').removeClass('is--active')
            $('.cake').removeClass('is--active')
            return
          }
          if (index === 1) {
            $(this).css({
              "left": `${40 + (172 * index)}px`,
              'background-position-x': `-225px`
            })
            $('.draw').addClass('is--active')
            $('.welfare').removeClass('is--active')
            $('.qx').removeClass('is--active')
            $('.xrj').removeClass('is--active')
            $('.cake').removeClass('is--active')
            return
          }
          if (index === 2) {
            $(this).css({
              "left": `${40 + (172 * index)}px`,
              'background-position-x': `-411px`
            })
            $('.qx').addClass('is--active')
            $('.welfare').removeClass('is--active')
            $('.draw').removeClass('is--active')
            $('.xrj').removeClass('is--active')
            $('.cake').removeClass('is--active')
            return
          }
          if (index === 3) {
            $(this).css({
              "left": `${40 + (172 * index)}px`,
              'background-position-x': `-594px`
            })
            $('.xrj').addClass('is--active')
            $('.welfare').removeClass('is--active')
            $('.draw').removeClass('is--active')
            $('.qx').removeClass('is--active')
            $('.cake').removeClass('is--active')
            return
          }
          if (index === 4) {
            $(this).css({
              "left": `${40 + (172 * index)}px`,
              'background-position-x': `-778px`
            })
            $('.cake').addClass('is--active')
            $('.welfare').removeClass('is--active')
            $('.draw').removeClass('is--active')
            $('.qx').removeClass('is--active')
            $('.xrj').removeClass('is--active')
            return
          }
        })
        //侧边栏切换
        $('.li-icon').on('click', function () {
          $(this).addClass("li--active").siblings().removeClass("li--active");
          var index = $(this).index()
          if (index === 0) {
            $('.li--active').css('background-position-y', '-64px')
            $('.occupation').addClass('is-active')
            $('.song').removeClass('is-active')
            $('.year').removeClass('is-active')
            $('.home').removeClass('is-active')
            return
          }
          if (index === 1) {
            $('.song').addClass('is-active')
            $('.occupation').removeClass('is-active')
            $('.year').removeClass('is-active')
            $('.home').removeClass('is-active')
          }
          if (index === 2) {
            $('.year').addClass('is-active')
            $('.occupation').removeClass('is-active')
            $('.home').removeClass('is-active')
            $('.song').removeClass('is-active')
          }
          if (index === 3) {
            location.reload()
          }
          $('.li--active').css('background-position-y', `-${64 + (156 * index)}px`)
        })
        //视频部分
        $('.video').click(function () {
          videoPlays()
          $('#close-video-alert').click(function () {
            $('#video-alert').hide();
            $('#indexVideo').empty();
            $('body').css({
              'overflow-y': 'visible'
            });
          });
        })
        function videoPlays() {
          $('#indexVideo').html('');
          var videObj = {
            id: 10,
            width: 740,
            height: 420,
            autoPlay: 1,
            isBig: 0,
            imgUrl: '',
            videoUrl: 'https://resource.15166.com/video/shqz/6zhounian.mp4',
            desc: ''
          }
          var flashvars = {
            f: videObj.videoUrl,
            c: 0,
            b: 1,
            p: 1,
            i: videObj.imgUrl
          };
          var video = [videObj.videoUrl + "->video/mp4"];
          CKobject.embed('https://shqz.15166.com/static/ckplayer/ckplayer/ckplayer.swf', 'indexVideo', 'ckplayer_indexVideo', videObj.width, videObj.height, false, flashvars, video)
          $('#video-alert').show();
        }
        $('.fix-bottom-control').click(function () {
          $('.footer').toggleClass('none');
          $('.fix-bottom-control').toggleClass('foot-active')
          $('.fix-bottom_top').toggleClass('fix-bottom_bottom')
        })
      })
    }
  }
  exports.sexennial = sexennial

});
